// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"8e1f149f","455":"3127b07b"}[chunkId] + ".chunk.js";
};